module.exports = require('./dist');



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-google-invisible-recaptcha/index.js
// module id = 1587
// module chunks = 7